<!-- //
商城-订单-详情
@auth xuyd
@date 2024-10-01
//-->
<template>
  <page-layout layout="C">
  </page-layout>
</template>

<script>
import OrderApi from '@/api/mall/order.api.js';

export default {
  name: 'ViewMallOrderMgmtOrderDetail',
  components: {},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
  ],
  data() {
    return {}
  }
}
</script>
